import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { DocumentServiceGateway } from 'src/app/application/gateway/DocumentServiceGateway';
import { PaymentGateway } from 'src/app/application/gateway/PaymentGateway';
import { Delivery } from 'src/app/domain/models/Delivery';
import { DeliveryDiscount } from 'src/app/domain/models/DeliveryDiscount';
import { GenericOrderDetail, ImportOrder, ImportOrderDetail } from 'src/app/domain/models/ImportOrder';
import { Payment } from 'src/app/domain/models/Payment';
import { BasicUser } from 'src/app/domain/models/User';
import { Routes } from 'src/app/infrastructure/routes';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-import-order-delivery',
  templateUrl: './import-order-delivery.component.html',
  styleUrls: ['./import-order-delivery.component.css'],

})
export class ImportOrderDeliveryComponent implements OnInit {

  @Input()
  importOrder: ImportOrder | undefined

  @Input()
  delivery: Delivery | undefined

  @Input()
  importOrderDetails: GenericOrderDetail[] = []

  @Input()
  discounts: DeliveryDiscount[] = []

  @Input()
  isClosedSale: boolean = false

  @Input()
  directSaleProgramId: number | undefined

  @Input()
  payments: Payment[] = []

  loading: boolean = false

  profile: BasicUser | undefined

  DefaultBookingText: string = "(As Booking info)"
  DefaultLoadingInfoText: string = "(Pending)"

  constructor(private _router: Router,
    private _messageService: MessageService,
    private _authService: AuthGateway,
    private _paymentService: PaymentGateway,
    private _documentService: DocumentServiceGateway,
    public translate: TranslateService) {

  }

  ngOnInit(): void {
    this.profile = this._authService.getUser()
  }

  goToPayments() {
    if(this.importOrder) {
      if(this.isClosedSale) {
        this._router.navigate(['/' + Routes.userClosedSalePaymentsPage, this.importOrder.guid, this.directSaleProgramId])
      }
      else
      {
        this._router.navigate(['/' + Routes.userPaymentsPage, this.importOrder.guid])
      }
    }
  }

  getDetailTotalPrice(detail: GenericOrderDetail): number {
    return detail.palletsQuantity > 0 && detail.boxesPerPallet > 0 ? detail.palletsQuantity * detail.boxesPerPallet * detail.price : detail.boxesQuantity * detail.price
  }

  getOrderTotalPrice(): number {
    let total = 0
    if(this.importOrderDetails) {
      this.importOrderDetails.forEach(x => {
        total += this.getDetailTotalPrice(x)
      })
    }
    return total
  }

  get totalCost(): number {
    if(this.delivery) {
      return this.getOrderTotalPrice() +
        (this.delivery.oceanFreight ? this.delivery.oceanFreight : 0) +
        (this.delivery.inland ? this.delivery.inland : 0) +
        (this.delivery.localCharges ? this.delivery.localCharges : 0) +
        (this.delivery.customs ? this.delivery.customs : 0) +
        (this.delivery.otherCosts ? this.delivery.otherCosts : 0) +
        (this.delivery.surcharge ? this.delivery.surcharge : 0) +
        (this.delivery.handling ? this.delivery.handling : 0) +
        (this.delivery.gateOut ? this.delivery.gateOut : 0) +
        this.qcReviewCost
    }
    return 0
  }

  get totalPayments(): number {
    let total = 0
    if(this.payments) {
      this.payments.forEach(x => {
        total += x.amount
      })
    }
    return total
  }

  get balance(): number {
    return this.totalPayments - this.totalCost + this.totalDiscounts
  }

  get absoluteBalance(): number {
    return Math.abs(this.balance)
  }

  getOpenSwiftDocument(url: string) {
    window.open(environment.apiUrl + url, '_blank');
  }

  getPaymentDocument(paymentId: number) {
    this._documentService.getPaymentDocument(paymentId).subscribe((resultBlob: any) => {
      var downloadURL = window.URL.createObjectURL(resultBlob.body);
      window.open(downloadURL);})
  }

  get qcReviewCost(): number {
    let total = 0
    if(this.importOrderDetails) {
      this.importOrderDetails.forEach(x => {
        total += x.originQCReviewPrice ? x.originQCReviewPrice : 0
      })
    }
    return total
  }

  get totalDiscounts(): number {
    let total = 0
    if(this.discounts) {
      this.discounts.forEach(x => {
        total += x.amount
      })
    }
    return total
  }
}
